import * as React from "react"

// 744px = ProERP-eigener `tablet`-Breakpoint (siehe globals.css) statt Tailwinds
// Standard-`md` (768px) — muss damit übereinstimmen, sonst rendert die Sidebar
// hier ihre Sheet-Variante (isMobile=true), obwohl der äußere `AppSidebar`-Wrapper
// (apps/web, `hidden tablet:flex`) sie längst sichtbar geschaltet hat.
const MOBILE_BREAKPOINT = 744

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}
